import React from 'react';
import Textarea from '../../../components/ui/Textarea';

function LongRunningAnalysisFields({ value, onChange }) {
  return (
    <div className="space-y-4">
      <label className="flex items-center gap-2 text-sm text-content-secondary">
        <input
          type="checkbox"
          checked={value.enabled}
          onChange={(event) => onChange({ ...value, enabled: event.target.checked })}
        />
        Processar análises expert em segundo plano
      </label>
      <p className="text-xs text-content-muted -mt-2">
        Pedidos classificados como análise ganham até 15 minutos em uma fila exclusiva.
        Mensagens novas aguardam a conclusão.
      </p>
      {value.enabled && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Textarea
            id="long_analysis_acknowledgement"
            label="Mensagem ao iniciar"
            value={value.acknowledgement}
            onChange={(event) =>
              onChange({ ...value, acknowledgement: event.target.value })
            }
            rows={3}
          />
          <Textarea
            id="long_analysis_failure_message"
            label="Mensagem em caso de falha"
            value={value.failureMessage}
            onChange={(event) =>
              onChange({ ...value, failureMessage: event.target.value })
            }
            rows={3}
          />
        </div>
      )}
    </div>
  );
}

export default LongRunningAnalysisFields;
